import { createContext, useState, useEffect } from 'react';
import api from '../api/axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // 1. Initialize User on App Load
    useEffect(() => {
        // Check Local Storage first (Persistent), then Session Storage (Temporary)
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        const userData = localStorage.getItem('user') || sessionStorage.getItem('user');

        if (token && userData) {
            try {
                setUser(JSON.parse(userData));
                // Optional: Ensure the API has the token immediately
                // api.defaults.headers.common['Authorization'] = `Bearer ${token}`; 
            } catch (e) {
                console.error("Error parsing user data", e);
                // If data is corrupted, clear everything
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
            }
        }
        setLoading(false);
    }, []);

    // 2. Login Function (Updated to handle Remember Me)
    const login = (token, userData, rememberMe = false) => {
        // First, clear any old data from both storages to prevent conflicts
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');

        if (rememberMe) {
            // Permanent Storage (Survives browser close)
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(userData));
        } else {
            // Temporary Storage (Dies on browser close)
            sessionStorage.setItem('token', token);
            sessionStorage.setItem('user', JSON.stringify(userData));
        }

        setUser(userData);
    };

    // 3. Logout Function
    const logout = () => {
        // Clear BOTH storages
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');

        setUser(null);
        window.location.href = '/';
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};